define('models/CategoryCollection',['underscore','ObjectCollection','LocalStorage','models/CategoryModel','app'],function (_,ObjectCollection,LocalStorage,CategoryModel,app) {
    //
    // Collection Category
    //
    var CategoryCollectionPrototype = {
        
        name:'CategoryCollection',
        route:'apiCategoryCollection',
        comparator:'position',
        
        model:CategoryModel,
        initialize:function(){
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this,arguments);
            //
        },
        allMenuCategories:function(){
            return new CategoryCollection(this.filter(function(c){
                return c.get('active_menu') || c.get('is_navigation_by_desire')
            }));
        },
        menuCategories:function(){
            return new CategoryCollection(this.where({active_menu:true}));
        },
        navigationbyDesireCategories:function(){
            return new CategoryCollection(this.where({is_navigation_by_desire:true}));
        },
        filterByProduct:function(id_product){
            return this.filter(function(category){
                return category.containsId(id_product);
            });
        },
        firstActiveInContext:function(){
            var cart = app.getCart();
            return this.filter(function (category) {
                return category.isVisibleInContext(cart) && !category.isEmpty(true, true, cart)
            }).shift();
        }
    };

    var CategoryCollection = ObjectCollection.extend(LocalStorage).extend(CategoryCollectionPrototype);

    return CategoryCollection;
});
